import {Component, OnDestroy} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {map, Observable, startWith, Subject} from 'rxjs';
import {Proposal} from '../../../model/proposal/proposal';

@Component({
    selector: 'app-proposal-form-base',
    template: '',
    standalone: false
})
export abstract class ProposalFormBase implements OnDestroy {
  abstract formGroup: FormGroup;
  protected destroy$ = new Subject<void>();

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  validStatus(): Observable<boolean> {
    return this.formGroup.valueChanges.pipe(
      map(() => this.formGroup.valid),
      startWith(this.formGroup.valid));
  }

  abstract updateProposal(proposal: Proposal): void;

  abstract autoFillForTransmission(proposal: Proposal): void;

  abstract autoFillForEdit(proposal: Proposal): void;

  abstract reset(): void;
}
